import Icons from "@/src/components/Icons";
import { useUserStore } from "@/src/store/useUserStore";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import { useLocation, useNavigate } from "react-router-dom";
import emptmom from "../../assets/img/emptMom.png";

function OrdersHeader() {
  const { user, avg } = useUserStore();

  let location = useLocation();
  let history = useNavigate();
  const isActive = (path: string) => location.pathname === path;
  return (
    <div className="flex header justify-between items-center gap-4 mb-5">
      <div className="item flex flex-col justify-center items-center w-2/12">
        {avg ? avg.toFixed(1) >= 4.1 ? <Icons name="emojiVeryHappy" size={40} /> : avg.toFixed(1) >= 4 && avg.toFixed(1) < 4.1 ? <Icons name="emojiHappy" size={40} /> : avg.toFixed(1) >= 3.8 && avg.toFixed(1) < 4 ? <Icons name="emojiNormal" size={40} /> : avg.toFixed(1) < 3.8 ? <Icons name="emojiSad" size={40} /> : null : <Icons name="emojiNull" size={40} />}
        <span className="flex gap-2 mt-3 justify-center items-center">
          <Icons name="star" />{" "}
          <b className="font-bold text-gray-300-mmpz text-[14px]">
            {avg ? digitsEnToFa(avg.toFixed(1)) : null}
          </b>
        </span>
      </div>
      <div className="item text-center w-10/12">
        <h5 className="text-2xl font-bold mb-3">سفارش</h5>
        <div className="button pt-1">
          <button
            onClick={() => history("/")}
            className={`border  px-2 py-3 min-w-[96px] rounded-r-2xl shadow-mmpz text-xs ${!isActive("/shipping")
              ? "border-primary-300"
              : "border-gray-100-mmpz"
              }`}
          >
            درحال پردازش
          </button>
          <button
            className={`border  px-2 py-3 min-w-[96px] rounded-l-2xl shadow-mmpz text-xs ${isActive("/shipping")
              ? "border-primary-300"
              : "border-gray-100-mmpz"
              } `}
            onClick={() => history("/shipping")}
          >
            منتظر ارسال
          </button>
        </div>
      </div>
      <div
        className="item flex justify-center flex-col items-center cursor-pointer w-2/12"
        onClick={() => history("/profile")}
      >
        <img
          src={
            user?.profilePictureUrl
              ?  user.profilePictureUrl
              : emptmom
          }
          className="rounded-full w-[50px] h-[50px] border border-gray-100-mmpz"
          alt=""
        />
        <span className="font-bold text-gray-300-mmpz text-[10px] pt-2 text-center">
          {user?.alias}
        </span>
      </div>
    </div>
  );
}

export default OrdersHeader;
